//考勤
export const departmentFind = '/erp/manage/department/find';//查询考勤人员
export const addRule = '/erp/attendance/addRule';//添加考勤组配置
export const updateRule = '/erp/attendance/updateRule';//编辑考勤组配置
export const queryRuleDetail = '/erp/attendance/queryRuleDetail';//查询考勤组详情
export const deleteRule = '/erp/attendance/deleteRule';//删除考勤组配置
export const queryStatistics = '/erp/attendance/queryStatistics';//考勤统计
export const queryManageList = '/erp/attendance/queryManageList';//考勤管理列表查询
export const updateAttendance = '/erp/attendance/updateAttendance';//考勤可以进行异常修改

//审批配置
export const queryDepartment = '/erp/manage/department/queryDepartment'; //查询所有门店
export const queryEmployeeNameByStoreId = '/erp/manage/employee/query'; //根据门店查员工
export const find = '/erp/manage/role/find'; //查询岗位
export const queryRuleList = '/erp/attendance/queryRuleList'; //查询考勤组
export const updateRuleStatus = '/erp/attendance/updateRuleStatus'; //编辑考勤组

//请假类型
export const addType = '/erp/manage/holiday/add'; //新增类型
export const queryType = '/erp/manage/holiday/query'; //查询类型
export const updateType = '/erp/manage/holiday/update'; //编辑类型
export const queryCheck = '/erp/check/queryCheck'; //查询审批流

//审批设置
export const addCheck = '/erp/check/addCheck'; //新增审批
export const querySet = '/erp/check/query'; //查询审批设置
export const updateSet = '/erp/check/update'; //编辑审批设置
export const queryDetail = '/erp/check/queryDetail'; //根据审批编号查询审批流配置

// 审批管理
export const addApplication = '/erp/apply/addApplication'; //新增请假申请
export const queryCheckEmployee = '/erp/apply/queryCheckEmployee'; //新增申请时查询审批人
export const queryCostApplication = '/erp/apply/queryCostApplication'; //查询请假申请
export const queryCostDetail = '/erp/apply/queryCostDetail'; //查询请假申请详情
export const updateStatus = '/erp/apply/updateStatus'; //修改审批状态
export const holidayQuery = '/erp/manage/holiday/query'; //查询请假类型列表
export const queryShifts = '/erp/apply/queryShifts'; //新增申请时查询班次

// 打卡
export const addClock = '/erp/clock/add'; //新增打卡
export const queryClockStatus = '/erp/clock/queryClockStatus'; //查询打卡状态

// 考勤日志
export const queryAttendancelog = '/erp/attendance/queryAttendancelog';//查看考勤日志考勤统计查询
export const excelList = '/erp/attendance/excel';//考勤统计导出

export const queryNoApprovalType = '/erp/check/queryNoApprovalType';//查询请假类型
export const queryFieldShifts = '/erp/apply/queryFieldShifts';//查询考勤班次